export default __webpack_public_path__ + "static/media/purplePurlers.96fdef3c.gif";